import React from "react";
import "./styles.css";
import AnalyticsCard from "../UI/analytics-card";
import { analyticsArray } from "../../constants/contents";

function Analytics() {
  return (
    <div className="analytics">
      <h1>
        Tus clientes están cada vez más activos en apps de mensajería como
        WhatsApp y FB Messenger
      </h1>
      <div className="analytics__cards">
        {analyticsArray.map((analytics) => (
          <AnalyticsCard
            title={analytics.title}
            subtitle={analytics.subtitle}
          />
        ))}
      </div>
    </div>
  );
}

export default Analytics;
